import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import { UserModule } from '@/store/modules/user'
import { PermissionModule } from '@/store/modules/permission'
// import i18n from '@/lang' // Internationalization
// import settings from './settings'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

const getPageTitle = (key: string) => {
  // const hasKey = i18n.te(`route.${key}`)
  // if (hasKey) {
  // const pageName = i18n.t(`route.${key}`)
  // return `${pageName} - ${settings.title}`
  // }
  // return `${settings.title}`
  return key
}

router.beforeEach(async(to: Route, from: Route, next: any) => {
  // Start progress bar
  NProgress.start()

  const useToLoggedIn =  UserModule.useToLoggedIn

  // console.log('window.innerWidth:', window.innerWidth)

  if (window.innerWidth < 768) {
    PermissionModule.SetIsMobile(true)
  } else {
    PermissionModule.SetIsMobile(false)
  }

  // Determine whether the user has logged in
  if (useToLoggedIn) {
    console.log("曾经登陆过")
    const isLoggedIn = UserModule.isLoggedIn

    if (isLoggedIn) {
      if (to.path === '/login') {
        // If is logged in, redirect to the home page
        console.log('#已经登陆过了，跳转到首页 路径为,', from.path, '=>', to.path, '=>', '/')
        next({ path: '/' })
        NProgress.done()
      } else {
        // Check whether the user has obtained his permission roles
        if (!UserModule.hasInitedPermission) {
          console.log('已经登陆过了, 请求的不是登陆页面， 而且没有进行权限设置， 路径为,', from.path, '=>', to.path)
          try {
            // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
            // await UserModule.GetUserInfo()
            // const roles = UserModule.roles
            const permissions = UserModule.permissions
            // Generate accessible routes map based on role
            PermissionModule.GenerateRoutes(permissions)

            // Dynamically add accessible routes
            PermissionModule.dynamicRoutes.forEach(route => {
              router.addRoute(route)
            })

            router.addRoute({
              path: '*',
              redirect: '/404',
              meta: { hidden: true }
            })

            // // console.log(PermissionModule.dynamicRoutes)
            // // console.log(router.getRoutes())

            UserModule.InitPermissionFlag()
            // Hack: ensure addRoutes is complete
            // Set the replace: true, so the navigation will not leave a history record

            console.log('已经登陆过了, 但是登陆后还想去别的地方， 而且没有进行权限设置， 此处进行权限设置，路径为,', from.path, '=>', to.path)
            router.replace(to.path)
          } catch (err) {
            // Remove token and redirect to login page
            UserModule.ResetToken()
            Message.error(err instanceof Error ? err.message : 'Has Error')
            console.log('#已经登陆过了, 但是请求的不是登陆页面， 而且没有进行权限设置， 此处进行权限设置失败了，从,', from.path, '=>', to.path, '失败了, 现在重新从', from.path, '定向到到login?redirect=', to.path)
            next(`/login?redirect=${to.path}`)
            NProgress.done()
          }
        } else {
          console.log('已经登陆过了, 请求的不是登陆页面， 而且已经进行了权限设置， 路径为, 路径通过,', from.path, '=>', to.path)
          next()
        }
      }
    } else {
      // 曾经登陆过所以有token，但是这次没有登陆还
      const success = await UserModule.LoginWithToken()
      if (success) {
        console.log('曾经登陆过所以有token, 且这次登陆成功了， 路径为,', from.path, '=>', to.path)

        if (!UserModule.hasInitedPermission) {
          console.log('已经登陆过了, 请求的不是登陆页面， 而且没有进行权限设置， 路径为,', from.path, '=>', to.path)
          try {
            // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
            // await UserModule.GetUserInfo()
            // const roles = UserModule.roles
            const permissions = UserModule.permissions
            // Generate accessible routes map based on role
            PermissionModule.GenerateRoutes(permissions)

            // Dynamically add accessible routes
            PermissionModule.dynamicRoutes.forEach(route => {
              router.addRoute(route)
            })

            // console.log(PermissionModule.dynamicRoutes)
            // // console.log(router.getRoutes())
            router.addRoute({
              path: '*',
              redirect: '/404',
              meta: { hidden: true }
            })

            UserModule.InitPermissionFlag()
            // Hack: ensure addRoutes is complete
            // Set the replace: true, so the navigation will not leave a history record

            console.log('已经登陆过了, 但是登陆后还想去别的地方， 而且没有进行权限设置， 此处进行权限设置，路径为,', from.path, '=>', to.path)
            router.replace(to.path)
          } catch (err) {
            // Remove token and redirect to login page
            UserModule.ResetToken()
            Message.error(err instanceof Error ? err.message : 'Has Error')
            console.log('#已经登陆过了, 但是请求的不是登陆页面， 而且没有进行权限设置， 此处进行权限设置失败了，从,', from.path, '=>', to.path, '失败了, 现在重新从', from.path, '定向到到login?redirect=', to.path)
            next(`/login?redirect=${to.path}`)
            NProgress.done()
          }
        }else {
          next()
        }
      } else {
        console.log('曾经登陆过所以有token, 但是这次登陆失败了， 路径为,', from.path, '=>', to.path, '=>', '/login?redirect=', to.path)
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }

  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      console.log('没有登陆过， 但是在白名单中， 路径为, 初次通过', from.path, '=>', to.path)
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      console.log('#没有登陆过， 又不在白名单中，要先登录， 路径为,', from.path, '=>', to.path)
      router.replace(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done()

  // set page title
  document.title = getPageTitle(to?.meta?.title)
})
